<template>
  <section class="navbar">
    <nav class="navbar__section">
      <ul
        :class="{ 'no-margin-last-child': !hasActivePhysicalUserCard }"
        class="navbar__list a-font__nav"
      >
        <li
          v-for="(item, index) in navbarItems"
          :key="item.name"
          class="navbar__item"
        >
          <router-link
            :key="index"
            class="navbar__link"
            :class="{ main: index === 0 }"
            :to="item.path"
            @click="onNavClick(item.path)"
          >
            <component :is="item.icon" />
            {{ $t(item.title) }}
          </router-link>
        </li>
      </ul>
    </nav>
    <BaseDialog
      v-model="visible"
      width="1137"
    >
      <PInvitation @close="popupClose" />
    </BaseDialog>
  </section>
</template>

<script lang="ts">
import PInvitation from '@/projects/mti/components/popups/p_invitation/p_invitation.vue';
import { navbarItems } from '@/projects/mti/components/TheNavbar/items';
import { useDialog } from '@/shared/composition/useDialog';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import { useAuthStore } from '@/shared/store/useAuthStore';
import { useUserStore } from '@/shared/store/useUserStore';
import {
  useRoute,
} from '@intlify/vue-router-bridge';
import {
  defineComponent,
  watch,
} from 'vue';
import './TheNavbar.scss';
import { metrikaReachGoal } from '@/shared/lib/analytics/metrika';

export default defineComponent({
  name: 'NavBar',
  components: { BaseDialog, PInvitation },
  setup(_props) {
    const userStore = useUserStore();
    const { hasActivePhysicalUserCard } = userStore;
    const $route = useRoute();

    const authStore = useAuthStore();

    const logout = authStore.logoutFromKC;

    const { isVisible: isVisibleOnMobile, toggle: toggleMobileMenu } = useDialog();

    watch(
      () => $route,
      () => {
        isVisibleOnMobile.value = false;
      },
    );

    return {
      logout,
      isVisibleOnMobile,
      hasActivePhysicalUserCard,
      toggleMobileMenu,
      navbarItems,
    };
  },

  data() {
    return {
      tokenOut: false,
      visible: false,
    };
  },
  methods: {
    popupClose() {
      this.visible = false;
      this.tokenOut = false;
    },
    onNavClick(path: any) {
      const p = typeof path === 'string' ? path : (path?.path || '');

      if (!p) return;

      const чистый = String(p).split('?')[0].split('#')[0];

      if (чистый === '/my/' || чистый === '/my') metrikaReachGoal('main');
      else if (чистый.startsWith('/my/invites')) metrikaReachGoal('invite');
      else if (чистый.startsWith('/my/catalog/products')) metrikaReachGoal('catalog');
      else if (чистый.startsWith('/my/rules')) metrikaReachGoal('rules');
      else if (чистый.startsWith('/my/orders')) metrikaReachGoal('orders');
    },
  },
});
</script>
